import React, { forwardRef } from 'react';
import { Dialog } from 'tamagui';
import { ActivityIndicator, Keyboard, Pressable, ScrollView, Text, TextInput, View } from 'react-native';
import { XStack, YStack, Button, TextArea, Adapt, Sheet } from 'tamagui';
import { themeSelector } from '@reduxLocal/selectors/themeSelector';
import GenerateSchemaForm, { SchemaObject } from '@hooks/generateSchemaForm';
import _ from 'lodash';
import { SchemaItem } from "@types/handleFieldType"
type CustomDialogProps = {
  title: string;
  onPress?: (vals: any) => void;
  children?: React.ReactNode;
  customStyling?: object;
  schema?: [SchemaItem];
  trigger?: React.ReactNode;
  confirmText?: string;
  cancelText?: string;
}

type _ = {

}

const CustomDialog = forwardRef<_, CustomDialogProps>((props, ref) => {
  const [open, setOpen] = React.useState(false);
  const theme = themeSelector();
  const formRef = React.useRef(null);

  return (
    <Dialog>
      <Dialog.Trigger asChild>
        {props.trigger ? (
          // When a custom trigger is provided, use it directly so we don't
          // wrap Pressables/Buttons inside another Pressable that can swallow
          // the onPress event (as seen in the canvas toolbar).
          props.trigger
        ) : (
            <Pressable style={{ flex: 1 }}>
              <Button>{props.title}</Button>
            </Pressable>
        )}
      </Dialog.Trigger>
      <Adapt platform="touch">
        <Sheet animation="medium" zIndex={200000} modal >
          <Sheet.Frame padding="$4" maxHeight={"80%"} gap="$4">
            <Adapt.Contents />
          </Sheet.Frame>
          <Sheet.Overlay
            style={{ maxHeight: "80%" }}
            animation="lazy"
            enterStyle={{ opacity: 0 }}
            exitStyle={{ opacity: 0 }}
          />
        </Sheet>
      </Adapt>
      <Dialog.Portal
      >
        <Dialog.Overlay
          animation="quick"
          opacity={0.5}
          style={{ zIndex: 1000, padding: 50 }}
          enterStyle={{ opacity: 0 }}
          exitStyle={{ opacity: 0 }}
        />
        <Dialog.Content
          bordered
          key={"dialog-content"}
          elevate
          animation={[
            'quick',
            {
              opacity: {
                overshootClamping: true,
              },
            },
          ]}
          enterStyle={{ x: 0, y: -20, maxHeight:"80%", opacity: 0 }}
          exitStyle={{ x: 0, y: 10, opacity: 0 }}
          x={0}
          minWidth={300}
          maxWidth="90%"
          width="90%"
          opacity={1}
          y={0}
        >
          <YStack gap="$3" paddingHorizontal="$3" paddingVertical="$3">
            <Dialog.Title onPress={() => {
              Keyboard.dismiss();
            }} style={{ fontSize: 18, color: theme ? "black" : "white" }}>{props.title}</Dialog.Title>

            <ScrollView style={{ maxHeight: 300 }}>
              <GenerateSchemaForm
                ref={formRef}
                scrollEnabled={false}
                bottomPadding={20}
                customStyling={{ minHeight: 100 }}
                schema={props.schema || [{
                  type: 'product_select',
                  content: { helpText: "Simply select a product and I can do the heavy lifting" },
                  title: 'Product',
                  ref: 'product_select'
                }]}
                hideButton
              />
            </ScrollView>

            <XStack gap="$2" width="100%" paddingTop="$3">
              <Dialog.Close displayWhenAdapted asChild>
                <Button flex={1} size="$3">
                  {props.cancelText || "Cancel"}
                </Button>
              </Dialog.Close>
              <Dialog.Close asChild>
                <Button
                  flex={1}
                  size="$3"
                  theme="active"
                  onPress={async () => {
                    console.log("formRef.current?.getValues()", formRef.current?.values);
                    if (props.onPress) {
                      await props.onPress(formRef.current?.values);
                    }
                  }}
                >
                  {props.confirmText || "submit"}
                </Button>
              </Dialog.Close>
            </XStack>
          </YStack>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog>
  )
});
export default CustomDialog;